import React, {PureComponent, ReactNode} from "react"
import {Query as QueryComponent, pagination} from "@irati/utils/services/apollo"
import {Query} from "@irati/utils/apollo"
import {get} from "lodash"

import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import {ApolloState} from "@irati/utils/services/apollo/apolloStateInterface"
import {StatementItemList, TransactionList} from "@irati/types"

const query = gql`
  query RewardWalletTransactions($tenantId: String!, $userId: String!, $walletId: String!, $limit: Int, $cursor: String) {
    rewardStatementItems(tenantId: $tenantId, userId: $userId, walletId: $walletId, limit: $limit, cursor: $cursor) {
      cursor
      hasMore
      results {
        uuid
        availableBalance
        transfer {
          sourceWallet
          destinationWallet
          currency
          amount
          createdAt
          type
          useCreditToBuyReward {
            rewardOrder {
              recipients {
                results {
                  firstname
                  lastname
                }
              }
              reward {
                thumbnailImage
              }
            }
          }
          sendCreditAsReward {
            recipientUserId
            rewardOrder {
              recipients {
                results {
                  firstname
                  lastname
                }
              }
              createdBy {
                firstname
                lastname
              }
              reward {
                thumbnailImage
              }
            }
          }
        }
      }
    }
  }
`
export const getTransactionsKey = getQueryNames(query)[0]

interface RewardWalletTransactionsVariables {
  tenantId: string
  userId: string
  walletId: string
  limit: number
  cursor: string
}

export interface RewardWalletTransactionsData extends TransactionList {
  data: {
    rewardStatementItems: StatementItemList
  }
}
export function getTransactionList(apollo: ApolloState) {
  const transactions: RewardWalletTransactionsData = get(apollo, `data[${getTransactionsKey}]`, {})
  const {results = [], cursor, limit, hasMore, offset} = transactions

  return {
    results,
    limit,
    cursor,
    hasMore,
    offset
  }
}
interface Props {
  variables: RewardWalletTransactionsVariables
  children(state: ApolloState): ReactNode
}

class TypedQuery extends Query<RewardWalletTransactionsData, RewardWalletTransactionsVariables> {}

export default class RewardWalletTransactionsQuery extends PureComponent<Props> {
  render() {
    return (
      <QueryComponent
        query={query}
        QueryComponent={TypedQuery}
        notifyOnNetworkStatusChange
        useError={false}
        useLoader={false}
        {...this.props}>
        {(apolloState: ApolloState) => {
          const fetchMore = (vars: RewardWalletTransactionsVariables) => {
            return pagination(
              {
                query,
                variables: vars
              },
              apolloState
            )
          }
          return this.props.children({...apolloState, fetchMore})
        }}
      </QueryComponent>
    )
  }
}
import {gql} from "@irati/utils/gql"
